import metamask from "./metamask.js";
import walletconnect from "./walletconnect.js";
export default async function (type, config) {
  if (type === "metamask") {
    return metamask();
  } else {
    return walletconnect(config.infuraId);
  }
}